import { clientApi } from './clientApi.js'

export const clientServe = {
  ...clientApi,
}
